import './jquery-global.js';
import './rails.js';

import 'jquery-ui-dist/jquery-ui.js';
$.fn.datepicker = undefined;
import 'jquery-mousewheel';
import 'date-functions';
import 'selectivity/jquery.js';

import '../../../app/assets/javascripts/vendor/jquery.storageapi.js';
import './jquery-datetimepicker.js';
import '../../../app/assets/javascripts/vendor/highcharts/highcharts.js';
import '../../../app/assets/javascripts/vendor/highcharts/modules/data.js';
